







































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class WorkflowView extends Vue {
  public items: Common.Workflow[] = new Array();
  public params: Common.WorkflowQuery = new Common.WorkflowQuery();
  public importQuery = new Common.ImportQuery('ワークフロー', 'Workflow');
  public exportQuery = new Common.ExportQuery('ワークフロー', this.params);
  public updated() {}
  public sortOptions: any = [
    { value: 'id', text: 'ID' },
    { value: 'workflow', text: 'フロー区分' },
    { value: 'name', text: '名称' },
  ];
}
